module.exports = __webpack_public_path__ + "static/bg-cb.9461666c.png";